import React from "react";
import Link from "next/link";
import FadeInAnimation from "../../Common/FadeInAnimation";
import { useTranslations } from '../../../locales/useTranslations';
import { BiChevronRight, BiBuildings, BiLogoVisualStudio, BiLogoChrome, BiMobile } from "react-icons/bi";


const PowerBiWeitereServices = () => {
  const { t } = useTranslations();
  return (
    <>
      <div className="services-area ptb-70">
        <div className="container">
          <div className="section-title text-left">
            <span className="sub-title">{t('powerBi_weitereServices_title')}</span>
            <h2>{t('powerBi_weitereServices_title2')}</h2>
          </div>

          <FadeInAnimation direction="up" delay={100}>
            <div className="container">
              <div className="row">
                <div className="col-sm-6">
                  <Link href="/it-consulting" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiBuildings />
                      </div>
                      <h3>{t('powerBi_weitereServices_title3')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('powerBi_weitereServices_description3') }} />
                      <span className="features-box-action">{t('powerBi_weitereServices_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiBuildings />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/software-development/" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiLogoVisualStudio />
                      </div>
                      <h3>{t('powerBi_weitereServices_title4')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('powerBi_weitereServices_description4') }} />
                      <span className="features-box-action">{t('powerBi_weitereServices_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiLogoVisualStudio />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/app-development/" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiMobile />
                      </div>
                      <h3>{t('powerBi_weitereServices_title5')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('powerBi_weitereServices_description5') }} />
                      <span className="features-box-action">{t('powerBi_weitereServices_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiMobile />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/web-development/" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiLogoChrome />
                      </div>
                      <h3>{t('powerBi_weitereServices_title6')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('powerBi_weitereServices_description6') }} />
                      <span className="features-box-action">{t('powerBi_weitereServices_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiLogoChrome />
                      </div>
                    </div>
                  </Link>
                </div>

              </div>
            </div>
          </FadeInAnimation>

        </div>
      </div>
    </>
  );
};

export default PowerBiWeitereServices;
